var map = {
	"./plan1_s.svg": "ed51",
	"./plan2_s.svg": "cdeb",
	"./plan3_s.svg": "b7b0",
	"./plan4_s.svg": "8b1a",
	"./plan5_s.svg": "c463",
	"./plan6_s.svg": "b09f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ff81";